export const SkipRule = {
    SINGLE: 'single',
    MAJORITY: 'majority',
    EVERYONE: 'everyone'
}